import './style/index.js';

import _Attachments from './attachments';

export const Attachments = _Attachments;
export default Attachments;

export * from './type';
